import { useSearchParam } from "lib/@hooks/use-search-param"
import { Box, IconButton, InputAdornment, TextField } from "@mui/material"
import { setFromEvent } from "lib/setFromEvent"
import Iconify from "minimals-template/components/Iconify"
import { useCleanDebouncedValue } from "routes/facilities/plugins/helpers/use-clean-debounced-value"

export function SearchBoxUsingSearchParam({
    autoFocus = true,
    placeholder = "Search by schedule title or code...",
    variant = "standard",
    startAdornment,
    textFieldProps = {},
    // Two search boxes on one page need their own URL parameters
    param = "search",
    ...props
}) {
    const [labelSearch, setLabelSearch] = useSearchParam(param, "")
    const [search, setSearch] = useCleanDebouncedValue(labelSearch, 500, setLabelSearch)

    return (
        <Box py={2} m="auto" {...props}>
            <TextField
                className="search-param-box"
                data-cy="search-param-box"
                inputProps={{ "data-cy": "search-param-input" }}
                fullWidth
                value={search}
                autoFocus={autoFocus}
                onChange={setFromEvent(setSearch)}
                variant={variant}
                InputProps={{
                    startAdornment: startAdornment ? (
                        <InputAdornment position="start">{startAdornment}</InputAdornment>
                    ) : null,
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="Clear search"
                                size="small"
                                onClick={() => setSearch("")}
                                data-cy="clear-search-button"
                            >
                                <Iconify icon="ic:round-clear" />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
                placeholder={placeholder}
                {...textFieldProps}
            />
        </Box>
    )
}
